// import "server-only";

export const token = process.env.NEXT_PUBLIC_SANITY_API_READ_TOKEN || process.env.SANITY_API_READ_TOKEN;

export function requireToken() {
  if (!token) {
    throw new Error('Missing SANITY_API_READ_TOKEN');
  }

  return token;
}
